import map from 'lodash/map';
import { orderBy } from 'natural-orderby';
import { postDataPromise } from 'brock-fetch-utils';
import { handleErrorResult } from '../../viewDashboards/utils/fetchUtils';
import i18next from '../translations/i18n';

function setOptionTextFieldValueField(option, translations) {
    const updatedOption = {
        ...option,
        textField: translations?.[option.id] ?? option.description,
        valueField: option.id,
    };

    delete updatedOption.id;
    delete updatedOption.description;

    if (updatedOption.children) {
        updatedOption.children = updatedOption.children.map((child) =>
            setOptionTextFieldValueField(child, translations)
        );
    }

    return updatedOption;
}

export function mapSelectOptions(selectOptions) {
    return selectOptions.map((selectOption) => {
        const translations = selectOption.translations?.[i18next.language];

        return {
            ...selectOption,
            options: orderBy(
                selectOption.options.map((option) =>
                    setOptionTextFieldValueField(option, translations)
                ),
                'textField'
            ),
        };
    });
}

export function getSelectOptionsPromise(uri, filterConfigurations, setError) {
    const apiKeys = map(filterConfigurations, (filter) => filter.apiKey).filter(
        (x) => x
    );

    return postDataPromise(uri, apiKeys).then(mapSelectOptions, (error) =>
        handleErrorResult(error, setError)
    );
}

export function getSelectOptionsForApiKeys(uri, apiKeys, setError) {
    return postDataPromise(uri, apiKeys).then(mapSelectOptions, (error) =>
        handleErrorResult(error, setError)
    );
}
